import { apiEmpleo } from "../../util/ApiEmpleo";
import { TContractPhase } from "./contract.types";

export type TUpdateContractPhaseBody = {
  demoteReason?: string;
};

const apiUpdateContractPhase = async (
  contractId: string,
  phase: TContractPhase,
  options?: TUpdateContractPhaseBody
) => {
  const body: Record<string, string> = { phase };
  if (options?.demoteReason) {
    body.demote_reason = options.demoteReason;
  }
  const res = await apiEmpleo.patch(
    `contracts/${contractId}/phase`,
    body,
    {
      headers: {
        "Content-Type": "application/merge-patch+json",
      },
    }
  );

  return res;
};

export { apiUpdateContractPhase };
